import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './i18n';
import { initVisitorFromPath } from './visitorContext.js';
import { initAnalytics } from './analytics.js';

initVisitorFromPath();
initAnalytics();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element');
}
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <Suspense fallback="... is loading ...">
      <App />
    </Suspense>
  </HelmetProvider>
);
